import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "user-profile"
};
const _hoisted_2 = {
  class: "main-wrap user-profile-wrap"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "账号信息", -1);
const _hoisted_4 = {
  class: "card setting-card"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "实名信息", -1);
const _hoisted_6 = {
  class: "card setting-card"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "常用信息", -1);
const _hoisted_8 = {
  class: "card setting-card"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_cell = _resolveComponent("van-cell");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_nav_bar, {
    title: $setup.title
  }, null, 8, ["title"]), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_cell, {
    class: "avatar",
    title: "头像",
    label: "头像用于个性化场景展示",
    "is-link": ""
  }, {
    value: _withCtx(() => [_createVNode(_component_van_image, {
      width: "36px",
      height: "36px",
      round: "",
      src: require('@/assets/img/default-avata.png')
    }, null, 8, ["src"])]),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "昵称",
    label: "设置的昵称会显示给他人",
    "is-link": ""
  }, {
    value: _withCtx(() => [_createTextVNode(_toDisplayString($setup.userData && $setup.userData.nick_name ? $setup.userData.nick_name : "未设置"), 1)]),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "手机号码",
    label: "手机号作为账号的登录名称",
    "is-link": ""
  }, {
    value: _withCtx(() => [_createTextVNode(_toDisplayString($setup.userData && $setup.userData.phone_number ? $setup.userData.phone_number.substr(0, 3) + "****" + $setup.userData.phone_number.substr(7, 4) : "--"), 1)]),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "登录密码",
    label: "设置密码可以提高安全性",
    value: "未设置",
    "is-link": ""
  }), _createVNode(_component_van_cell, {
    title: "电子邮箱",
    label: "添加电子邮箱有助账户安全",
    "is-link": ""
  }, {
    value: _withCtx(() => [_createTextVNode(_toDisplayString($setup.userData && $setup.userData.email ? $setup.userData.email : "未设置"), 1)]),
    _: 1
  })]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_cell, {
    title: "证件信息",
    label: "证件信息是账号的重要凭据",
    value: "未设置",
    "is-link": ""
  })]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_cell, {
    title: "紧急联系人",
    label: "紧急状态下联系紧急联系人",
    value: "未设置",
    "is-link": ""
  }), _createVNode(_component_van_cell, {
    title: "通勤设置",
    label: "添加通勤信息打车更便捷",
    value: "未设置",
    "is-link": "",
    onClick: $options.goCommute
  }, null, 8, ["onClick"])])])]);
}